module.exports = __webpack_public_path__ + "images/cloud-right.33dc26c7.png";